module.exports = __webpack_public_path__ + "img/checkbox-checked-violet.4ad5ef6f.svg";